/* HC okt 2026: quick view / Choose options op een productkaart opent op dezelfde variant als de kaartlink
   (type-chip Driver/Fairway/Hybrid of het gekozen kleurbolletje). Geladen via snippets/hc-copy-fixes.liquid. */
(function () {
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('product-card quick-view');
    if (!q) return;
    var card = q.closest('product-card');
    var a = card && card.querySelector('a.product-card-title');
    var m = a && (a.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    if (!m) return;
    var vid = m[1];
    var old = document.querySelector('#Product-Drawer-Content variant-selects');
    var tries = 0;
    (function wait() {
      var vs = document.querySelector('#Product-Drawer-Content variant-selects');
      if (!vs || vs === old) {
        if (++tries < 60) setTimeout(wait, 100);
        return;
      }
      var js = vs.querySelector('script[type="application/json"]');
      var data;
      try { data = JSON.parse(js.textContent); } catch (err) { return; }
      var v = data.filter(function (x) { return String(x.id) === vid; })[0];
      if (!v) return;
      var radios = [].slice.call(vs.querySelectorAll('input[type=radio]'));
      var names = [];
      radios.forEach(function (r) { if (names.indexOf(r.name) < 0) names.push(r.name); });
      v.options.forEach(function (o, i) {
        var r = radios.filter(function (x) { return x.name === names[i] && x.value === o; })[0];
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    })();
  }, true);
})();
/* HC 14 okt 2026 (Donny): quick view-galerij net als de PDP.
   Het theme zet de foto van de gekozen variant bovenaan (en toont de eerste variantfoto dubbel).
   Hier: dubbele foto weg, foto's altijd in de normale volgorde van het product, en de galerij scrolt naar
   de foto van de gekozen variant (je komt midden in de reeks uit en kunt naar boven en beneden).
   B9-overname (14 okt, t117): niets verspringen bij een variantkeuze. Alleen de fotostrook zelf schuift (rustig) naar de gekozen foto,
   het paneel blijft 1,5 s op zijn plek staan (het theme scrolt anders terug naar boven). */
(function () {
  var lastKey = '', lastG = null, busy = false, raf = 0, holdUntil = 0, holdTop = 0, holdEl = null;
  function canScroll(sc) {
    var cs = getComputedStyle(sc);
    return { x: /(auto|scroll)/.test(cs.overflowX) && sc.scrollWidth > sc.clientWidth + 2, y: /(auto|scroll)/.test(cs.overflowY) && sc.scrollHeight > sc.clientHeight + 2 };
  }
  /* 15 okt: strook heeft op mobiel scroll-padding (uitlijning met de titel), daar rekening mee houden */
  function pads(g) { var cs = getComputedStyle(g); return { l: parseFloat(cs.scrollPaddingLeft) || 0, t: parseFloat(cs.scrollPaddingTop) || 0 }; }
  function toSlide(g, a, smooth) {
    if (!a) return false;
    var c = canScroll(g);
    if (!c.x && !c.y) return true;
    var p = pads(g), r0 = a.getBoundingClientRect(), b0 = g.getBoundingClientRect();
    var r = { left: r0.left, top: r0.top, width: r0.width, height: r0.height }, b = { left: b0.left + p.l, top: b0.top + p.t };
    /* ver weg (meer dan 2 foto's): direct, anders schuift de strook zichtbaar langs alle foto's */
    var far = (c.x && Math.abs(r.left - b.left) > 2.2 * r.width) || (c.y && Math.abs(r.top - b.top) > 2.2 * r.height);
    var L = c.x ? g.scrollLeft + r.left - b.left : g.scrollLeft, T = c.y ? g.scrollTop + r.top - b.top : g.scrollTop;
    /* 17 okt (Donny): smooth scrollen ging op iPhone in slow motion; nu een korte eigen animatie (200 ms) */
    if (!(smooth && !far)) { cancelAnimationFrame(g.__hcA); g.__hcA = 0; g.scrollTo({ left: L, top: T, behavior: 'instant' }); return true; }
    fast(g, L, T);
    return true;
  }
  function fast(g, L, T) {
    /* al onderweg naar dezelfde foto: niet opnieuw starten (herstarten gaf een lange, trage uitloop) */
    if (g.__hcA && Math.abs(g.__hcTL - L) < 2 && Math.abs(g.__hcTT - T) < 2) return;
    cancelAnimationFrame(g.__hcA); g.__hcTL = L; g.__hcTT = T;
    var x0 = g.scrollLeft, y0 = g.scrollTop, t0 = performance.now(), D = 200;
    if (g.__hcSn == null) g.__hcSn = g.style.scrollSnapType;
    g.style.scrollSnapType = 'none';
    (function st(n) {
      var k = Math.min(1, Math.max(0, (n - t0) / D)), e = 1 - Math.pow(1 - k, 3);
      g.scrollTo({ left: x0 + (L - x0) * e, top: y0 + (T - y0) * e, behavior: 'instant' });
      if (k < 1) g.__hcA = requestAnimationFrame(st); else { g.__hcA = 0; g.style.scrollSnapType = g.__hcSn; g.__hcSn = null; }
    })(t0);
  }
  function inView(g, a) {
    var p = pads(g), r = a.getBoundingClientRect(), b = g.getBoundingClientRect();
    return Math.abs(r.left - b.left - p.l) < 4 && Math.abs(r.top - b.top - p.t) < 4;
  }
  /* 15 okt: het theme (setActiveMedia) zet bij elke keuze de foto vooraan, scrolt de strook naar 0 en op desktop de pagina naar boven.
     Daardoor vloog de strook eerst terug en dan langs alle foto's. Voor de drawer vervangen: alleen is-active zetten en rustig naar de foto schuiven. */
  function patch() {
    var vs = document.querySelector('#Product-Drawer variant-selects');
    if (!vs || vs.__hcSam) return;
    vs.__hcSam = 1;
    vs.setActiveMedia = function (m) {
      if (!m) return;
      var sl = this.productSlider || m.parentElement;
      [].forEach.call(sl.querySelectorAll('[data-media-id]'), function (e) { e.classList.remove('is-active'); });
      try { if (this.setImageSetMedia) this.setImageSetMedia(); } catch (err) {}
      m.classList.add('is-active');
      var g = m.parentElement;
      lastG = g; lastKey = m.getAttribute('data-media-id');
      toSlide(g, m, true);
    };
  }
  function fix() {
    raf = 0;
    patch();
    var g = document.querySelector('#Product-Drawer .product-quick-images');
    if (!g || busy) return;
    busy = true;
    try {
      var seen = {};
      [].slice.call(g.children).forEach(function (k) {
        var id = k.getAttribute('data-media-id');
        if (!id) return;
        if (seen[id]) { if (seen[id].classList.contains('is-active')) k.classList.add('is-active'); seen[id].remove(); }
        seen[id] = k;
      });
      var kids = [].slice.call(g.children);
      if (g.getAttribute('data-hc-order') !== '1') {
        kids.forEach(function (k, i) { k.setAttribute('data-hc-i', i); });
        g.setAttribute('data-hc-order', '1');
      }
      var sorted = kids.slice().sort(function (x, y) { return (+x.getAttribute('data-hc-i') || 0) - (+y.getAttribute('data-hc-i') || 0); });
      var moved = sorted.some(function (k, i) { return kids[i] !== k; });
      if (moved) sorted.forEach(function (k) { g.appendChild(k); });
    } finally { busy = false; }
    var a = g.querySelector('.product-quick-images__slide.is-active');
    var key = (a && a.getAttribute('data-media-id')) || '';
    if (g !== lastG) { lastG = g; lastKey = ''; }
    if (!key) return;
    /* vlak na een keuze: als het theme de strook terugzet, rustig terug naar de gekozen foto */
    if (key === lastKey) { if (Date.now() < holdUntil && !inView(g, a)) toSlide(g, a, true); return; }
    var first = lastKey === '';
    if (!toSlide(g, a, !first)) return;
    lastKey = key;
    if (first) setTimeout(function () { if (lastKey === key) toSlide(g, a, false); }, 350);
  }
  /* variantkeuze in de drawer: direct naar de foto van de nieuwe variant schuiven en het paneel vasthouden */
  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('#Product-Drawer variant-selects');
    if (!vs) return;
    patch();
    var panel = vs.closest('.side-panel-content') || document.querySelector('#Product-Drawer .side-panel-content');
    holdUntil = Date.now() + 1500; holdEl = panel; holdTop = panel ? panel.scrollTop : 0;
    /* 15 okt: bij een variantwissel verbergt Shopify de betaalknoppen (Buy with Shop) even; het koopblok wordt ~95px korter
       en het paneel springt omhoog. Hoogte van het koopblok 2,5 s vastzetten, dan blijft de scrollpositie staan. */
    [].forEach.call(document.querySelectorAll('#Product-Drawer .add_to_cart_holder'), function (w) {
      if (!w.__hcMh) w.style.minHeight = w.offsetHeight + 'px';
      clearTimeout(w.__hcMh); w.__hcMh = setTimeout(function () { w.style.minHeight = ''; w.__hcMh = 0; }, 2500);
    });
    var d; try { d = JSON.parse(vs.querySelector('script[type="application/json"]').textContent); } catch (err) { return; }
    var names = []; [].forEach.call(vs.querySelectorAll('input[type=radio]'), function (r) { if (names.indexOf(r.name) < 0) names.push(r.name); });
    var sel = names.map(function (n) { var r = vs.querySelector('input[type=radio][name="' + n + '"]:checked'); return r ? r.value : null; });
    var v = d.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
    var m = v && v.featured_media && v.featured_media.id;
    var g = document.querySelector('#Product-Drawer .product-quick-images');
    var a = m && g && g.querySelector('[data-media-id$="-' + m + '"]');
    if (a) { lastG = g; lastKey = a.getAttribute('data-media-id'); toSlide(g, a, true); }
  }, true);
  document.addEventListener('scroll', function (e) {
    if (!holdEl || Date.now() > holdUntil || e.target !== holdEl) return;
    if (Math.abs(holdEl.scrollTop - holdTop) > 2) holdEl.scrollTop = holdTop;
  }, true);
  ['wheel', 'touchstart'].forEach(function (ev) { document.addEventListener(ev, function (e) { if (holdEl && e.target.closest && e.target.closest('#Product-Drawer')) holdUntil = 0; }, { capture: true, passive: true }); });
  new MutationObserver(function (ms) {
    if (busy || raf) return;
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target;
      if (t.closest && t.closest('#Product-Drawer')) { raf = setTimeout(fix, 30); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
